module.exports = __webpack_public_path__ + "img/lang-en.b1914370.svg";